import { render } from "./QuantoDoar.vue?vue&type=template&id=5fd5da54&scoped=true&ts=true"
import script from "./QuantoDoar.vue?vue&type=script&lang=ts"
export * from "./QuantoDoar.vue?vue&type=script&lang=ts"

import "./QuantoDoar.vue?vue&type=style&index=0&id=5fd5da54&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd5da54"]])

export default __exports__